import { graphql, useStaticQuery } from 'gatsby'

const useFeaturedTipsheets = () => {
  const {
    allContentfulTipsheet: { edges },
  } = useStaticQuery(
    graphql`
      query SiteTipsheetsQuery {
        allContentfulTipsheet(
          filter: {
            featured: { eq: true },
            node_locale: { eq: "fr" },
          }
          sort: { updatedAt: DESC }
          skip: 0
          limit: 3
        ) {
          edges {
            node {
              slug
              title
              category {
                slug
              }
            }
          }
        }
      }
    `
  )

  return edges.map(({ node }) => node)
}

export default useFeaturedTipsheets
